import VerificationInputImport from 'react-verification-input';

// `react-verification-input` is CJS (`exports.default` + `__esModule`). Under
// Vite 8 / Rolldown the default import can resolve to the module namespace
// object instead of the component, so fall back to `.default` when present.
export const VerificationInput =
  (VerificationInputImport as { default?: typeof VerificationInputImport })
    .default ?? VerificationInputImport;
